import AppTabMenu from './AppTabMenu.vue';

export * from './types';
export default AppTabMenu;



// WEBPACK FOOTER //
// ./src/uikit/components/AppTabMenu/index.ts